import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import PrivaceSection from "../../components/PrivaceSection/PrivaceSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
const PrivacePage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Privacy Policy | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Review the Privacy Policy of Cash Flow Summit 2026 to understand how we collect, use, and protect your personal information."
        />
        <meta
          name="keywords"
          content="Cash Flow Summit privacy policy, data protection, personal information"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="noindex, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Privacy Policy"} pagesub={"Privacy Policy"} />
      <PrivaceSection />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default PrivacePage;
